var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StateRenderer',{attrs:{"lines":1}},[_vm._t("default",null,null,_vm.stores)],2)}
var staticRenderFns = []

export { render, staticRenderFns }